import { createContext, useContext, useEffect, useState } from 'react'
import { auth, db } from '../../firebase'
import { onAuthStateChanged, signOut } from 'firebase/auth'
import { doc, getDoc } from 'firebase/firestore'
import { useNavigate } from 'react-router-dom'

const AuthContext = createContext()
export const useAuth = () => useContext(AuthContext)

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [isAdmin, setIsAdmin] = useState(false)
  const [is2FA, setIs2FA] = useState(sessionStorage.getItem('2fa') === 'true')
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser)

        // Получаем роль из Firestore
        const docSnap = await getDoc(doc(db, 'users', currentUser.uid))
        if (docSnap.exists()) {
          const role = docSnap.data().role
          setIsAdmin(role === 'admin')
        } else {
          setIsAdmin(false)
        }
      } else {
        setUser(null)
        setIsAdmin(false)
        setIs2FA(false)
        sessionStorage.removeItem('2fa')
      }
      setLoading(false)
    })

    return unsub
  }, [])

  const confirm2FA = () => {
    setIs2FA(true)
    sessionStorage.setItem('2fa', 'true')
  }

  const logout = async () => {
    await signOut(auth)
    setUser(null)
    setIsAdmin(false)
    setIs2FA(false)
    sessionStorage.removeItem('2fa')
    navigate('/auth')
  }

  return (
    <AuthContext.Provider value={{ user, isAdmin, is2FA, loading, confirm2FA, logout }}>
      {!loading && children}
    </AuthContext.Provider>
  )
}
